import { createSlice } from '@reduxjs/toolkit';
import MatchConfidenceLevel from '../../../Data/MatchConfidenceLevel';
import MatchingSupplierCountSource from '../../../Data/MatchingSupplierCountSource';

export const components = createSlice({
  name: 'SUPPLIER_MATCHES',
  initialState: [], // this comes from preloadedState in the store
  reducers: {
    setCustomerMatches(state, action) {
      // Indicates the specific supplier matches tailored for the customers input selections.
      const { payload } = action;
      const { customerMatches } = payload;

      return {
        ...state,
        customerMatches,
      };
    },

    setSubcategoryMaxMatches(state, action) {
      const { payload } = action;
      const { subcategoryMaxMatches } = payload;

      return {
        ...state,
        subcategoryMaxMatches,
      };
    },

    setRequiresLegalStatementAboveNav(state, action) {
      const { payload } = action;
      const { requiresLegalStatementAboveNav } = payload;

      return {
        ...state,
        requiresLegalStatementAboveNav,
      };
    },

    setMatchLevel(state, action) {
      const { payload } = action;
      const { matchLevel } = payload;

      return {
        ...state,
        matchLevel,
      };
    },

    setSupplierMatchSelectionEnabled(state, action) {
      const { payload } = action;
      const { supplierMatchSelectionEnabled } = payload;

      return { ...state, supplierMatchSelectionEnabled };
    },

    setMatchingSupplierCount(state, action) {
      const { payload } = action;
      const { matchingSupplierCount, matchingSupplierCountSource } = payload;
      const shouldClearScheduledRequest =
        matchingSupplierCountSource === MatchingSupplierCountSource.MATCHES ||
        matchingSupplierCountSource === MatchingSupplierCountSource.FALLBACK;

      return {
        ...state,
        matchingSupplierCount,
        matchingSupplierCountSource,
        ...(shouldClearScheduledRequest
          ? {
              matchingSupplierCountRequestScheduled: false,
              matchingSupplierCountRequestComponentId: null,
            }
          : {}),
      };
    },

    setMatchingSupplierCountLoading(state, action) {
      const { payload } = action;
      const { isLoading, matchingSupplierCountLoadingSource } = payload;

      return {
        ...state,
        matchingSupplierCountLoading: isLoading,
        matchingSupplierCountLoadingSource,
      };
    },

    setMatchingSupplierCountRequestScheduled(state, action) {
      const { payload } = action;
      const { isScheduled, componentId = null } = payload;

      return {
        ...state,
        matchingSupplierCountRequestScheduled: Boolean(isScheduled),
        matchingSupplierCountRequestComponentId: isScheduled
          ? componentId
          : null,
      };
    },

    setMatchConfidence(state, action) {
      const { confidenceLevel, lastShownLevel } = action.payload;

      return {
        ...state,
        matchConfidence: {
          confidenceLevel:
            confidenceLevel !== undefined
              ? confidenceLevel
              : state.matchConfidence?.confidenceLevel ||
                MatchConfidenceLevel.NULL,
          lastShownLevel:
            lastShownLevel !== undefined
              ? lastShownLevel
              : state.matchConfidence?.lastShownLevel ||
                MatchConfidenceLevel.NULL,
        },
      };
    },

    setBrandMatchReasons(state, action) {
      const { payload } = action;
      const { brandMatchReasons } = payload;

      return {
        ...state,
        brandMatchReasons,
      };
    },

    setDynamicMatches(state, action) {
      const { dynamicMatches } = action.payload;
      return {
        ...state,
        dynamicMatches,
      };
    },

    setCustomerMatchesRequestStatus(state, action) {
      const { customerMatchesRequestStatus } = action.payload;

      return {
        ...state,
        customerMatchesRequestStatus,
      };
    },
  },
});

const { actions, reducer } = components;

export const {
  setCustomerMatches,
  setSubcategoryMaxMatches,
  setRequiresLegalStatementAboveNav,
  setMatchLevel,
  setSupplierMatchSelectionEnabled,
  setMatchingSupplierCount,
  setMatchingSupplierCountLoading,
  setMatchingSupplierCountRequestScheduled,
  setMatchConfidence,
  setBrandMatchReasons,
  setDynamicMatches,
  setCustomerMatchesRequestStatus,
} = actions;

export default reducer;
